<template>
    <CModal
      :title="title"
      :color="color"
      :show.sync="showModal"
    >   
        <CForm id="guest_confirm_form" method="POST" enctype="multipart/form-data">
          <CInput
            hidden
            :lazy="false"
            :value.sync="$v.form.id.$model"
            name="id"
            id="id"          
          />
          <CInput
            hidden
            :lazy="false"
            :value.sync="$v.form.confirm_method.$model"
            name="confirm_method"
            id="confirm_method"          
          />
          <CInput
            hidden
            :lazy="false"
            :value.sync="$v.form.is_confirm.$model"
            name="is_confirm"
            id="is_confirm"          
          />
          <CRow>      
            <CCol md="6">
              <CInput
                  label="Nombre:"
                  :lazy="false"
                  :value.sync="$v.form.name.$model"
                  name="name"
                  id="name"
                  placeholder=""
                  disabled
                />       
            </CCol>              
            <CCol md="6">
              <CInput
                label="N° Invitados:"
                :lazy="false"
                :value.sync="$v.form.tickets.$model"
                name="tickets"
                id="tickets"
                placeholder=""
                :disabled="!canEditTickets"
              />
            </CCol>                
          </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="store('2')" color="dark">No</CButton>
          <CButton @click="store('1')" color="success">Si</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, minValue, helpers } from "vuelidate/lib/validators"
import store from '@/store';
import ws from '@/services/events_guests';

export default {
  name: 'ConfirmGuestModal',
  props: {
  },
  components: {
  },
  data () {
    return {
      showModal: false,
      title: "Confirmar Invitado",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,      
      classesOptions: [],
      statusOptions: [],
    }
  },
  mounted: async function() {    
    
  },
  methods: {
    storeModal (item) {
      this.showModal = true;
      this.color = "success";
      this.title = 'Confirmar Invitado';
      this.isEdit = false;
      this.submitted = false;
      this.form = {
          id: item.id,
          name: item.name,
          tickets: Number(item.is_confirm) === 2 && Number(item.tickets) <= 0 ? 1 : Number(item.tickets),
          is_confirm: Number(item.is_confirm),
          confirm_method: "admin",
      };
    },
    updateModal (item) {
      this.showModal = true;
      this.color = "warning";
      this.title = 'Anular Confirmación Invitado';
      this.isEdit = true;
      this.submitted = false;

      this.form = {
          id: item.id,
          name: item.name,
          tickets: item.tickets,
          is_confirm: item.is_confirm,
          confirm_method: item.confirm_method,
      };
    },
    async store (is_confirm) {
      this.$v.$touch();

      if (this.isValid) {
        this.loading();
        this.submitted = true;

        let form = document.getElementById("guest_confirm_form");
        let formData = new FormData(form);
        formData.set("is_confirm",is_confirm);
        let response = "";
        response = await ws.confirm(formData);         
        
        this.loaded();
        this.showToast(response.type, response.message);
        if(response.type == "success"){
          this.$emit("refreshItems");
          this.closeModal();
        }                              
      }
    },
    closeModal () {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm () {
      return {
          id: 0,
          name: '',
          tickets: 1,
          confirm_method: "admin",
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
    canEditTickets () { return true },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      id: {        
      },
      name: {        
      },
      tickets: {
      },
      is_confirm:{
      },
      confirm_method:{
      },
    }
  },
}
</script>